import $ from 'jquery';
import layout from '../Layout';
import getHeaderOffset from '../helpers/getHeaderOffset';

export default class StickyHeader {
  constructor(options, settings) {
    this.postMessage = options.postMessage;
    this.$body = $(document.body);
    this.$window = $(window);
    this.$siteMain = $('.site-main');

    this.$el = options.$el;
    this.$toggle = options.$toggle;
    this.settings = settings;

    this.stickyClass = 'site-header-sticky';
    this.scrolledClass = 'site-header-sticky--scrolled';
    this.navOpenClass = 'site-header-sticky--open';

    this.$announcementBar = this.$el.find('.announcement-bar');
    this.header = this.$el[0];

    if (!this.settings.sticky_header) {
      return this._stickyReset();
    }

    // Revert navigation to original state on breakpoint change
    this.navVisibility = this.navVisibility.bind(this);
    layout.onBreakpointChange(this.navVisibility);

    this._stickyOffset = this._stickyOffset.bind(this);
    layout.onBreakpointChange(this._stickyOffset);

    this._toggleStickyHeader = this._toggleStickyHeader.bind(this);
    this._headerChecker = this._headerChecker.bind(this);

    this.slideToggle = this._slideToggle.bind(this);

    this._init();
  }

  closeNavigation() {
    if (!this.settings.sticky_header) return;

    this.$el.removeClass(this.navOpenClass).one('trend', () => {
      this.$body.trigger('position-banners');
    });
    this.postMessage('nav:close-all');
  }

  openNavigation() {
    this.$el.addClass(this.navOpenClass).one('trend', () => {
      this.$body.trigger('position-banners');
    });
  }

  navVisibility(event, breakpoints) {
    if (breakpoints.previous === 'L') this.closeNavigation();
  }

  unload() {
    if (!this.settings.sticky_header) return;

    this.$body.removeClass(this.stickyClass).removeClass(this.scrolledClass);

    this.$toggle.off('.sticky-header');
    this.$window.off('.sticky-header');

    layout.offBreakpointChange(this.navVisibility);
    layout.offBreakpointChange(this._stickyOffset);

    if (this.requestAnimationFrameId) {
      window.cancelAnimationFrame(this.requestAnimationFrameId);
    }
  }

  _init() {
    this._stickyOffset(true);
    this._bindEvents();

    if (window.requestAnimationFrame) {
      this._headerChecker();
    }
  }

  _bindEvents() {
    this.$toggle.on('click.sticky-header', (event) => {
      event.preventDefault();

      if (layout.isBreakpoint('L')) this._slideToggle();
    });

    this.$window.on('scroll.sticky-header', this._toggleStickyHeader);
  }

  _stickyReset() {
    this.$siteMain.css('paddingTop', '');
  }

  /**
   * Determine the offset when breakpoints change
   *  - Offset is used to determine scroll threshold
   *  - Offset is used to set a body offset on browsers that don't support Sticky
   *
   * @param isInit
   * @private
   */
  _stickyOffset(isInit) {
    if (!this.$body.hasClass(this.stickyClass)) {
      this.$body.addClass(this.stickyClass);
    }

    const offset = getHeaderOffset(this.header);

    this.$siteMain.css('paddingTop', offset);

    if (isInit) {
      this._toggleStickyHeader();
    }
  }

  /**
   * Open or close the navigation
   *
   * @param open
   * @private
   */
  _slideToggle(open = false) {
    if (this.$el.hasClass(this.navOpenClass) && !open) {
      this.closeNavigation();
      this.$toggle.removeClass('active');
    } else {
      this.openNavigation();
      this.$toggle.addClass('active');
    }
  }

  /**
   *
   *
   * @param hide
   * @private
   */
  _toggleAnnouncementBar(hide = false) {
    if (!this.$announcementBar.length) {
      return;
    }

    let top = 0;

    if (hide) {
      const mobileOnly = this.$announcementBar.hasClass('only-mobile');

      if ((layout.isBreakpoint('XS') && mobileOnly) || !mobileOnly) {
        top = this.$announcementBar.outerHeight() * -1;
      }
    }

    this.$el.css('top', top).one('trend', () => {
      this.$body.trigger('position-banners');
    });
  }

  /**
   * Sticky header only shows as sticky after scroll
   *
   * @private
   */
  _toggleStickyHeader() {
    if (this.$body.hasClass('scroll-lock')) {
      return;
    }

    const scrollThreshold = getHeaderOffset(this.header) + 20; // Extend threshold 20px past header
    const shouldShrink = window.pageYOffset > scrollThreshold;

    // Sticky header is scrolled, is and is visible -- nothing more to do!
    if (shouldShrink && this.$body.hasClass(this.scrolledClass)) {
      return;
    }

    if (shouldShrink) {
      this._shrink();
      this._toggleAnnouncementBar(true);
    } else {
      this._expand();
      this._toggleAnnouncementBar(false);
    }
  }

  _shrink() {
    this.closeNavigation();
    this.$toggle.removeClass('active');

    this.$el
      .revealer('show')
      .one('revealer-animating.sticky-header', () => {
        this.$body.addClass(this.scrolledClass).one('trend', () => {
          this.$body.trigger('position-banners');
        });
      });
  }

  _expand() {
    this.openNavigation();

    this.$el
      .revealer('hide')
      .one('revealer-animating.sticky-header', () => {
        this.$body.removeClass(this.scrolledClass).one('trend', () => {
          this.$body.trigger('position-banners');
        });
      })
      .one('revealer-hide.sticky-header', () => {
        this.$toggle.removeClass('active');
      });
  }

  _headerChecker() {
    // Periodically check to make sure header is offset correctly
    //this.requestAnimationFrameId = window.requestAnimationFrame(this._headerChecker);

    if (!this.$body.hasClass(this.scrolledClass)) {
      this._stickyOffset();
    }
  }
}
